import { __decorate, __metadata } from "tslib";
import { Component, Prop, Provide } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import { LvIcon } from "../icon";
import { LvCarouselTransition } from "./LvCarouselTransition";
export const SYM_LV_CAROUSEL = Symbol("LvCarousel");
export const COMPONENT_NAME = "LvCarousel";
/**
 * A carousel component
 */
let LvCarousel = class LvCarousel extends UIComponent {
    constructor() {
        super(...arguments);
        this.currentActiveIndex = 0;
        this.transitionName = "carousel-slide-right";
        this.nextIntervalId = null;
    }
    get self() {
        return this;
    }
    get children() {
        return this.$slots.default ?? [];
    }
    mounted() {
        this.setNextInterval();
    }
    setNextInterval() {
        if (!this.auto)
            return;
        if (this.nextIntervalId != null)
            this.clearNextInterval();
        this.nextIntervalId = setInterval(() => this.next(), this.interval);
    }
    clearNextInterval() {
        if (!this.auto)
            return;
        clearInterval(this.nextIntervalId);
        this.nextIntervalId = null;
    }
    resetNextInterval() {
        if (!this.auto)
            return;
        this.clearNextInterval();
        this.setNextInterval();
    }
    onMouseEnter() {
        this.clearNextInterval();
    }
    onMouseLeave() {
        this.setNextInterval();
    }
    /**
     * Go to the next slide.
     * <br>If the current slide is the last, the carousel will restart from the first.
     */
    next() {
        if (this.children.length == 0)
            return;
        this.transitionName = "carousel-slide-right";
        if (this.currentActiveIndex == this.children.length - 1) {
            this.currentActiveIndex = 0;
        }
        else {
            this.currentActiveIndex++;
        }
    }
    /**
     * Go to the previous slide.
     * <br>If the current slide is the first, the carousel will jump to the last.
     */
    previous() {
        if (this.children.length == 0)
            return;
        this.transitionName = "carousel-slide-left";
        if (this.currentActiveIndex == 0) {
            this.currentActiveIndex = this.children.length - 1;
        }
        else {
            this.currentActiveIndex--;
        }
    }
};
__decorate([
    Prop({ type: Number, required: false, default: 5000 }),
    __metadata("design:type", Number)
], LvCarousel.prototype, "interval", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvCarousel.prototype, "auto", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LvCarousel.prototype, "showControls", void 0);
__decorate([
    Provide(SYM_LV_CAROUSEL),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LvCarousel.prototype, "self", null);
LvCarousel = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: {
            LvIcon,
            LvCarouselTransition
        },
    })
], LvCarousel);
export default LvCarousel;
//# sourceMappingURL=script.js.map